import { useCallback } from "react";
import useFetchAndTrace from "../fetchWithTrace";
import settings from "../../../constants/settings";
import { fetchUserAttributes } from "aws-amplify/auth";

export default function useCheckAccountCreated() {
  const fetchAndTrace = useFetchAndTrace();

  const checkAccountHandler = useCallback((response: Response) => {
    if (!response.ok) {
      throw Error("Failed to check account status");
    }
  }, []);

  const errorHandler = useCallback(() => {
    throw Error("Failed to check account status");
  }, []);

  return useCallback(async () => {
    const userAttributes = await fetchUserAttributes();
    const userId = userAttributes["custom:flashpcb_user_id"];
    if (userId === undefined) {
      await fetchAndTrace(
        `${settings.api_url}/users`,
        checkAccountHandler,
        errorHandler,
        {
          method: "PUT",
        },
        false,
        true,
      );
      return await fetchUserAttributes();
    } else {
      return userAttributes;
    }
  }, [checkAccountHandler, errorHandler, fetchAndTrace]);
}
